import { render } from "./TheIndex.vue?vue&type=template&id=366608fa"
import script from "./TheIndex.vue?vue&type=script&lang=js"
export * from "./TheIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__